import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import { useAlphaOS } from "@/context/AlphaOSContext";

/**
 * ExamMode — el "silencio visual" (Zen). Cuando está activo, un lienzo negro
 * cubre TODA la app (chrome incluido): solo queda un temporizador minimalista
 * arriba a la derecha, un botón de salida, y el contenido que la página haya
 * declarado. Aquí renderizamos el marco; el contenido central lo pone quien
 * active el modo (o queda un lienzo limpio para estudiar sin pantalla).
 */
export default function ExamMode() {
  const { examMode, remaining, endExam } = useAlphaOS();
  const mm = String(Math.floor(remaining / 60)).padStart(2, "0");
  const ss = String(remaining % 60).padStart(2, "0");
  const low = remaining <= 60;

  return (
    <AnimatePresence>
      {examMode && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.6 }}
          className="fixed inset-0 z-[100] bg-[#050505] text-white flex flex-col"
          data-testid="exam-mode"
        >
          {/* temporizador minimalista, arriba a la derecha */}
          <div className="absolute top-6 right-6 flex items-center gap-4">
            <span
              className={`font-mono-alpha text-3xl md:text-5xl tabular-nums tracking-tight transition-colors ${low ? "text-alpha-red" : "text-white/85"}`}
              data-testid="exam-timer"
            >
              {mm}:{ss}
            </span>
            <button
              onClick={endExam}
              data-testid="exam-exit"
              className="w-10 h-10 rounded-full border border-white/20 text-white/60 hover:text-white hover:border-white flex items-center justify-center transition-colors"
              aria-label="Salir del Modo Examen"
            >
              <X className="w-5 h-5" />
            </button>
          </div>

          {/* espacio central de aislamiento */}
          <div className="flex-1 flex flex-col items-center justify-center px-8 text-center">
            <div className="font-mono-alpha text-[10px] uppercase tracking-[0.4em] text-alpha-red mb-6">Modo Examen</div>
            <div className="font-serif-display text-3xl md:text-5xl leading-tight max-w-2xl text-white/90">
              Silencio visual. Solo tú y lo que estás estudiando.
            </div>
            <p className="mt-6 text-white/40 text-sm max-w-md text-justify">
              Sin menús, sin notificaciones, sin nada más. Cuando el reloj llegue a cero, o cuando quieras, pulsa la X para volver.
            </p>
            {remaining === 0 && (
              <div className="mt-8 font-mono-alpha text-[11px] uppercase tracking-widest text-alpha-red animate-pulse">
                Tiempo cumplido — respira y revisa
              </div>
            )}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
